var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74378 2.47499L20.5782 11.3437C20.6954 11.4086 20.7931 11.5037 20.8611 11.6191C20.9292 11.7345 20.9651 11.866 20.9651 12C20.9651 12.134 20.9292 12.2655 20.8611 12.3809C20.7931 12.4963 20.6954 12.5914 20.5782 12.6562L4.74378 21.525C4.6104 21.5987 4.45774 21.63 4.30612 21.6147C4.15451 21.5995 4.01113 21.5385 3.89508 21.4397C3.77902 21.341 3.6958 21.2092 3.65649 21.062C3.61718 20.9148 3.62365 20.7591 3.67503 20.6156L6.47913 12.75L13 12.75C13.4142 12.75 13.75 12.4142 13.75 12C13.75 11.5858 13.4142 11.25 13 11.25L6.47914 11.25L3.67503 3.38436C3.62365 3.24091 3.61718 3.08521 3.65649 2.93799C3.6958 2.79076 3.77902 2.65901 3.89508 2.56026C4.01113 2.46152 4.15451 2.40046 4.30612 2.38523C4.45774 2.36999 4.6104 2.4013 4.74378 2.47499Z",
    fill: "#DDDDDD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSend);
export default __webpack_public_path__ + "static/media/ic-send.4dd8f912aa694deb3e07ce51e0c27917.svg";
export { ForwardRef as ReactComponent };